var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuggageDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#333333;stroke-width:0.75;}\n\t.st1{fill:#333333;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.7,6h12.7C18.7,6,19,6.3,19,6.6v13.6c0,0.3-0.3,0.6-0.6,0.6H5.7c-0.3,0-0.6-0.3-0.6-0.6V6.6 C5,6.3,5.3,6,5.7,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.1,5.6V2.3c0-0.6,0.4-1,1-1H14c0.6,0,1,0.4,1,1v3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.6,21.2c0,0.2,0,0.4,0.1,0.5C7.8,22,7.9,22.1,8,22.3c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1 c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5s0.1-0.4,0.1-0.5H9.1L7.6,21.2L7.6,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.5,21.2c0,0.2,0,0.4,0.1,0.5s0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1 c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.5H15H13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.4,9.9c0-0.2-0.2-0.4-0.4-0.4S8.6,9.7,8.6,9.9H9.4z M8.7,17c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4H8.7z  M8.7,9.9V17h0.8V9.9H8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.4,9.9c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4H12.4z M11.6,17c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4H11.6 z M11.6,9.9V17h0.8V9.9H11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.3,9.9c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4H15.3z M14.6,17c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4H14.6 z M14.6,9.9V17h0.8V9.9H14.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggageDark);
export default __webpack_public_path__ + "static/media/luggage-dark.340b3cd69e48632aa1b7b1ece618c100.svg";
export { ForwardRef as ReactComponent };